var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Button } from "@mui/material";
import { hideApplicationLoader, showApplicationLoader } from "common/ApplicationLoader";
import { DIALOG_TYPES } from "globals/global.constants";
import { openOverlayDialog } from "store/commonReducer/common.action";
import { store } from "store"; // for dispatch access outside hooks
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRetry = function () {
            var dispatch = store.dispatch;
            dispatch(showApplicationLoader());
            if (navigator.onLine) {
                window.location.reload();
            }
            else {
                dispatch(openOverlayDialog({
                    type: DIALOG_TYPES.NETWORK_ERROR,
                    data: {
                        errorCode: 0,
                        errorMessage: "You are still offline. Please check your internet connection.",
                    },
                }));
            }
            dispatch(hideApplicationLoader());
        };
        _this.state = {
            hasError: false,
            error: null,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        console.error("ErrorBoundary caught:", error, info);
    };
    ErrorBoundary.prototype.render = function () {
        var hasError = this.state.hasError;
        var styles = {
            mt1: {
                marginTop: '8px',
            },
        };
        if (hasError) {
            return (_jsxs(Box, { minHeight: 320, height: "100%", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", children: [_jsx("h2", { children: "Network Error: No internet or unstable connection. Please check your network." }), _jsx(Button, { sx: styles.mt1, size: "large", onClick: this.handleRetry, color: "primary", variant: "contained", children: "Reload" })] }));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
